import { useQuery } from "@tanstack/react-query";
import { UtilityConsumptionMeter } from "../models/UtilityConsumption";
import { getUtilityConsumptionMeters } from "../repositories/ConsumptionRepository";

export const useUtilityConsumptionMeters = ({
	targetId,
	enabled = true,
	externalMeterIds,
}: {
	targetId: number | null;
	enabled?: boolean;
	externalMeterIds: string[] | null;
}) => {
	const query = useQuery<UtilityConsumptionMeter[], Error>({
		queryKey: ["utility-consumption-meters", targetId],
		queryFn: ({ signal }) => getUtilityConsumptionMeters(targetId, signal),
		enabled,
		staleTime: 60_000,
		refetchInterval: 60_000,
		refetchOnWindowFocus: true,
	});
	const configuredIds = query.data?.map((meter) => meter.ExternalMeterId) ?? [];
	const requestedIdSet = new Set(externalMeterIds ?? []);
	const selectedIds =
		externalMeterIds === null
			? null
			: configuredIds.filter((meterId) => requestedIdSet.has(meterId));
	const resolvedExternalMeterIds =
		selectedIds === null ||
		selectedIds.length === 0 ||
		selectedIds.length === configuredIds.length
			? null
			: selectedIds;

	const isEmptySelection =
		query.data !== undefined &&
		selectedIds !== null &&
		selectedIds.length === 0;

	return { ...query, resolvedExternalMeterIds, isEmptySelection };
};
